module.exports = __webpack_public_path__ + "img/HiwaQader-KoshkaSuraka.ad63c8f6.jpg";